export interface DeviceUiSettingsState {
	deviceResetInProgress: boolean;
}

export function getDeviceUiSettingsStateId(deviceId: string): string {
	return `${deviceId}-settings`;
}
